export default {
  methods: {
    realVisits(item) {
      const visits4Show = []
      let prevVisit
      let notOptimized
      let pickups = 0
      let dropoffs = 0

      for (const visit of item.visits) {
        this.notOptimized = this.notOptimized === true || visit.order === null || false
        if (visit.type + '-' + visit.place_id !== prevVisit) {
          visit.shipping_ids = [visit.shipping_id]
          visits4Show.push(visit)
          if (visit.type === 'pickup') {
            pickups++
          } else {
            dropoffs++
          }
        } else {
          if (visit.visited === 1) {
            visits4Show[(visits4Show.length - 1)].visited = 1
          }
          visits4Show[(visits4Show.length - 1)].shipping_ids.push(visit.shipping_id)
        }
        prevVisit = visit.type + '-' + visit.place_id
      }

      item.pickups = pickups
      item.dropoffs = dropoffs
      item.visits4Show = visits4Show
      item.notOptimized = notOptimized
      return item
    }
  }
}
